import { QdzElement, bottomBarOffset, define, motion } from '@qdz/element';

export class QdzFloating extends QdzElement {
  #frame = 0;

  mount() {
    const toggle = this.ref('toggle');
    const top = this.ref('top');
    if (toggle) {
      this.listen(toggle, 'click', () => this.#setOpen(this.ref('panel').hidden));
      this.listen(this, 'keydown', (event) => {
        if (event.key !== 'Escape' || this.ref('panel').hidden) return;
        this.#setOpen(false);
        toggle.focus();
      });
      this.listen(document, 'click', (event) => {
        if (!this.contains(event.target)) this.#setOpen(false);
      });
    }
    if (top) {
      this.listen(top, 'click', () => window.scrollTo({ top: 0, behavior: motion.scroll() }));
    }
    const update = () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#offset());
    };
    for (const type of ['scroll', 'resize']) this.listen(window, type, update, { passive: true });
    this.listen(document, 'qdz:bottom-bar', update);
    this.#offset();
  }

  unmount() {
    cancelAnimationFrame(this.#frame);
  }

  #setOpen(open) {
    this.ref('panel').hidden = !open;
    this.ref('toggle').setAttribute('aria-expanded', String(open));
  }

  #offset() {
    this.style.setProperty('--qdz-float-offset', `${bottomBarOffset()}px`);
  }
}

define('qdz-floating', QdzFloating);
